import { render, staticRenderFns } from "./PageMeusDados.vue?vue&type=template&id=47da3bdf&scoped=true&"
import script from "./PageMeusDados.vue?vue&type=script&lang=js&"
export * from "./PageMeusDados.vue?vue&type=script&lang=js&"
import style0 from "./PageMeusDados.vue?vue&type=style&index=0&id=47da3bdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47da3bdf",
  null
  
)

export default component.exports